{
  "agreement_retention_period": "Agreement retention period",
  "allow_sync_with_external_service": "Allow synchronization of contact details with external services",
  "allow_sync_with_external_service_description": "Enable this option to automatically sync contact details with external services, ensuring that your information stays up to date across platforms",
  "consent_declined": "Consent declined",
  "consent_expired": "Consent expired",
  "consent_expiring": "Consent expiring",
  "consent_no": "No consent",
  "consent_received": "Consent received",
  "consent_requested": "Consent requested",
  "data_protection": "Data protection",
  "email_content": "{type_title} email footer",
  "enable_consent": "Enable {type_title} compliance",
  "gdpr_consent": "GDPR Consent",
  "increase_manually_description": "Increase period",
  "increase_manually_enter_days": "Enter additional days",
  "increase_manually_title": "Change manually",
  "manage_data": "Activate this option to ensure your data handling practices comply with {type_title} regulations, safeguarding user privacy and data security.",
  "notification_settings_gdpr_consent_caption": "When your candidate responds to the GDPR consent",
  "personal_data_protection": "Personal data protection",
  "privacy_policy_link": "Privacy policy link",
  "privacy_policy_text": "Privacy policy text",
  "privacy_policy_text_added": "Added",
  "privacy_policy_required": "Add a privacy policy link or text",
  "privacy_policy_text_placeholder": "Paste your privacy policy text",
  "remaining_consent_period": "Remaining consent period",
  "request_accept": "Give consent for data processing",
  "request_decline": "Deny data processing",
  "request_delete": "Removal request",
  "request_delete_description": "You are about to request to remove your profile from their database",
  "request_edit": "Request profile correction",
  "request_edit_description": "You are about to request to correct or update your profile in their database",
  "request_to_delete": "Request to delete",
  "request_to_edit": "Request to edit",
  "response_sent_accept_content": "Thank you for accepting our request to collect and process your personal data in compliance with GDPR regulations. Your consent allows us to proceed with handling your information securely and in accordance with our data protection policies.\n\nYou can review or withdraw your consent at any time by contacting us.",
  "response_sent_accept_title": "Thank you for accepting our GDPR consent request ",
  "response_sent_decline_content": "We have received your response declining our request to collect and process your personal data.",
  "response_sent_decline_title": "GDPR consent declined",
  "response_sent_delete_content": "We have received your request to delete your personal data in compliance with GDPR regulations. Please note that this process may take 30 days to complete. \n\nIf you have any questions or wish to stop this process, please contact us as soon as possible.",
  "response_sent_delete_title": "Confirmation of your data deletion request",
  "response_sent_edit_content": "We have received your request to update or correct your personal data. Our team is currently reviewing your request, and the necessary changes will be applied within 30 days.\n\nIf we need further clarification or information to proceed with the edits, we will reach out to you. \n\nThank you for ensuring your data stays accurate with us.",
  "response_sent_edit_title": "Confirmation of your data edit request",
  "send_request": "Send request",
  "settings_data_protection_description": "Manage privacy and data handling",
  "settings_title": "Configure {type_title} consents",
  "status_request_declined": "Declined {count_days} ago",
  "status_request_expired": "Expired {count_days} ago",
  "status_request_given": "Active for more {count_days}",
  "status_request_not_sent": "Not sent",
  "status_request_requested": "{count_days} ago, click to resend",
  "title_request_declined": "{type_title} consent declined",
  "title_request_empty": "Request {type_title} consent",
  "title_request_expired": "{type_title} consent expired",
  "title_request_expiring": "{type_title} consent will expire soon",
  "title_request_given": "{type_title} consent is received",
  "title_request_requested": "{type_title} consent requested",
  "type_ccpa": "CCPA",
  "type_fz152": "FZ-152",
  "type_gdpr": "GDPR",
  "unlock_btn": "Request {type_title} unlock",
  "unlock_content": "Our {type_title} email automation helps you effortlessly manage data retention extensions by sending reminders when consent periods are about to expire. \nTo ensure a personal touch and maintain the highest standards of communication, all emails are sent from our own accounts. This approach allows us to carefully monitor and manage each campaign, ensuring that only the most relevant recipients receive these important updates. \nWe understand the importance of maintaining your brand’s integrity, so automatic mass emailing is not enabled by default. If you’re interested in activating this feature, click the button below, and our team will reach out to guide you through the setup process.",
  "unlock_title": "Enhance your data compliance with {type_title} email consents",
  "~": "~"
}
